import { Roles } from '@/@types/auth.types';
import { useUserRole } from '@/features/identity/hooks/useUserRole';
import SuperAdminDashboardPage from '@/features/superAdmin/features/dashboard/SuperAdminDashboardPage';
import DashboardPage from '@/features/dashboard/DashboardPage';

const DashboardPageRouter = () => {
	const userRole = useUserRole();

	if (userRole === Roles.superAdmin) {
		return <SuperAdminDashboardPage />;
	}

	return <DashboardPage />;
};

export default DashboardPageRouter;
